import { LanguagesCode } from "@/config/languages";
import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { generatePath, useLocation, useNavigate, useParams } from "react-router-dom";

export const useLanguage = () => {
  const {
    i18n: { language, changeLanguage },
  } = useTranslation();

  const params = useParams();

  const { pathname } = useLocation();

  const navigate = useNavigate();

  const handleChangeLanguage = useCallback(
    (lang: LanguagesCode) => {
      const newPath = generatePath(pathname.replace(params.lang!, ":lang"), {
        ...params,
        lang,
      });

      if (language !== lang) changeLanguage(lang);

      navigate(newPath, { replace: true });
    },
    [changeLanguage, navigate, pathname, params, language],
  );

  useEffect(() => {
    if (params.lang !== language) {
      handleChangeLanguage(language as LanguagesCode);
    }
  }, [params.lang, language, handleChangeLanguage]);

  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.key === "i18nextLng" && e.newValue) {
        const newLang = e.newValue.slice(0, 2);
        if (language !== newLang) {
          changeLanguage(newLang);
        }
      }
    };

    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, [changeLanguage, language]);

  return {
    language,
    changeLanguage: handleChangeLanguage,
  };
};
